import { Button } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

const TYPE_FORM_EN = 'https://factorial.typeform.com/to/D3RFmEq8'
const TYPE_FORM_ES = 'https://factorial.typeform.com/to/igWzGtKA'
const TYPE_FORM_IT = 'https://factorial.typeform.com/to/nnVzjIuk'
const TYPE_FORM_DE = 'https://factorial.typeform.com/to/AcaApVcw'

const internationalizedTypeFormMap: Record<string, string> = {
  ['en']: TYPE_FORM_EN,
  ['es']: TYPE_FORM_ES,
  ['it']: TYPE_FORM_IT,
  ['de']: TYPE_FORM_DE,
}

const getTypeFormValue = (locale: string) => {
  return internationalizedTypeFormMap[locale] || TYPE_FORM_EN
}

export const DeveloperPartnersBanner = () => {
  return (
    <Callout
      title={i18n.t('marketplace.integrations.call_to_action.title')}
      description={i18n.t('marketplace.integrations.call_to_action.description')}
      type="info"
      action={
        <Button
          type="secondary"
          onClick={() => window.open(getTypeFormValue(i18n.locale), '_blank')}
        >
          {i18n.t('marketplace.integrations.call_to_action.button_text')}
        </Button>
      }
    />
  )
}
